import { dimensions } from 'helpers/dimensions';
import Events from 'events/events';

'use strict';

var DepartmentList = function (departmentList, index) {

  var _this = this;
  var localStorage = window.localStorage;

  _this.visibleNumberToStart = (localStorage && localStorage.getItem('departmentListLimit')) ? localStorage.getItem('departmentListLimit') : 5;
  _this.visibleChunkRepeat = (localStorage && localStorage.getItem('departmentListChunk')) ? localStorage.getItem('departmentListChunk') : 5;
  _this.startIndex = 0;
  _this.departmentList = departmentList;
  _this.idValue = "department-list-" + index;
  _this.departmentList.setAttribute("id", _this.idValue);
  _this.departmentListItems = _this.departmentList.querySelectorAll('.menu--facets-department-list .menu-item--facets');
  _this.multiselectDepartments =  _this.departmentList.querySelectorAll('.menu--facets-department-list .menu-item--multiselect');
  _this.departmentListArray = [].slice.call(_this.departmentListItems);
  _this.departmentItemHeight = dimensions.getElementHeight(_this.departmentListItems[0], false);
  _this.expandHeight = calculateExpandHeightAmount(_this.visibleNumberToStart);
  _this.numberOfExtraDepartments = countAdditionalDepartments();

  if ((_this.numberOfExtraDepartments > 0) && (_this.multiselectDepartments.length < 1)) {

    _this.departmentList.style.height = _this.expandHeight + 'px';
    _this.hiddenDepartments = getAdditionalDepartments();
    _this.expandButtonText = document.createTextNode(getLabelForShowMoreButton());
    _this.expandButton = document.createElement('button');
    _this.expandButton.appendChild(_this.expandButtonText);
    _this.expandButton.classList.add('button');
    _this.expandButton.classList.add('button--expand');
    _this.expandButton.setAttribute('aria-controls', _this.idValue);
    _this.departmentList.parentNode.insertBefore(_this.expandButton, _this.departmentList.nextSibling);
    bindEvents();
  }

  // for multiselect, we add an additional class which introduces scrollbars
  if(_this.multiselectDepartments.length > 0) _this.departmentList.classList.add('menu--overflow');

  setupAriaHiddenAttributes();

  function bindEvents() {
    if (_this.expandButton) {
      _this.expandButton.addEventListener('click', function (e) {
        e.preventDefault();
        showMoreHiddenDepartments();
      });
    }
  }

  function showMoreHiddenDepartments() {
    if (hasMoreHiddenDepartments()) {
      showNextHiddenDepartments();
    } else if (hasLastHiddenDepartments()) {
      showRemainingHiddenDepartments();
    }
  }

  function hasMoreHiddenDepartments() {
    return (_this.numberOfExtraDepartments > _this.visibleChunkRepeat);
  }

  function hasLastHiddenDepartments() {
    return ((_this.numberOfExtraDepartments > 0) && (_this.numberOfExtraDepartments <= _this.visibleChunkRepeat));
  }

  function getLabelForShowMoreButton() {
    if (hasMoreHiddenDepartments()) {
      return `Show next ${_this.visibleChunkRepeat} departments`;
    } else if (hasLastHiddenDepartments()) {
      return `Show all departments`;
    } else {
      return '';
    }
  }

  function hasNoHiddenDepartments() {
    return (_this.numberOfExtraDepartments <= 0);
  }

  function showNextHiddenDepartments() {

    var updateHeight = _this.departmentList.clientHeight + calculateExpandHeightAmount(_this.visibleChunkRepeat);

    _this.numberOfExtraDepartments -= _this.visibleChunkRepeat;
    _this.departmentList.style.height = updateHeight + 'px';
    _this.startIndex = _this.startIndex + _this.visibleChunkRepeat;

    if (hasLastHiddenDepartments()) {
      _this.departmentList.parentNode.querySelector('.button').innerHTML = 'Show all departments';
    } else if (hasNoHiddenDepartments()) {
      _this.departmentList.parentNode.removeChild(_this.expandButton);
    }

    setupAriaHiddenAttributes();
  }

  function showRemainingHiddenDepartments() {
    _this.expandHeight = calculateExpandHeightAmount(_this.numberOfExtraDepartments);
    _this.departmentList.style.height = _this.departmentList.clientHeight + _this.expandHeight + 'px';
    _this.startIndex = _this.startIndex + _this.numberOfExtraDepartments;
    _this.numberOfExtraDepartments -= _this.numberOfExtraDepartments;

    if (hasNoHiddenDepartments()) {
      _this.departmentList.parentNode.removeChild(_this.expandButton);
    }

    setupAriaHiddenAttributes();
  }

  function calculateExpandHeightAmount(numberDepartments) {
    const nextDepartments = _this.departmentListArray.splice(0, numberDepartments);

    return nextDepartments.reduce((total, item) => {
      const height = dimensions.getElementHeight(item, false);
      return total += height;
    }, 0);
  }

  function countAdditionalDepartments() {
    var listItemCount = _this.departmentListItems.length;
    return Math.max(0, listItemCount - _this.visibleNumberToStart);
  }

  function getAdditionalDepartments() {
    var preppedListItems = [];
    for (var i = _this.visibleNumberToStart; i < _this.departmentListItems.length; i++) {
      preppedListItems.push(_this.departmentListItems[i]);
    }
    return preppedListItems;
  }

  function setupAriaHiddenAttributes() {
    var cutoff = parseInt(_this.visibleNumberToStart, 10) + _this.startIndex;

    for (var i = 0; i < _this.departmentListItems.length; i++) {
      if (i < cutoff) {
        _this.departmentListItems[i].setAttribute('aria-hidden', 'false');
      } else {
        _this.departmentListItems[i].setAttribute('aria-hidden', 'true');
      }
    }
  }
};

function init() {
  var departmentLists = document.querySelectorAll('#department-list');
  [].forEach.call(departmentLists, function (list, index) {
    new DepartmentList(list, index);
  });
}

if ('querySelector' in document) {
  init();
  Events.facetListLoaded.register(init);
}
